import { render, staticRenderFns } from "./designers.vue?vue&type=template&id=1ad98837&scoped=true&"
import script from "./designers.vue?vue&type=script&lang=js&"
export * from "./designers.vue?vue&type=script&lang=js&"
import style0 from "./designers.vue?vue&type=style&index=0&id=1ad98837&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad98837",
  null
  
)

export default component.exports